import PlaceTokens from "@/utils/constants/PlaceTokens.ts";
import NamaPlace from "@/utils/presenters/NamaPlace.ts";
import Translator from "@/utils/common/Translator.ts";

export default class ReportLauncherPlace extends NamaPlace {

  get reportId(): string | undefined {
    return this.query[PlaceTokens.PRM_ID];
  }

  set reportId(value: string | undefined) {
    this.query[PlaceTokens.PRM_ID] = value;
  }

  get tempPrintId(): string | undefined {
    return this.query[PlaceTokens.PRM_TEMP_PRINT_ID];
  }

  set tempPrintId(value: string | undefined) {
    this.query[PlaceTokens.PRM_TEMP_PRINT_ID] = value;
  }

  get questions(): string | undefined {
    return this.query[PlaceTokens.PRM_QUESTIONS];
  }

  set questions(value: string | undefined) {
    this.query[PlaceTokens.PRM_QUESTIONS] = value;
  }

  get format(): string | undefined {
    return this.query[PlaceTokens.PRM_OUTPUT_FORMAT];
  }

  set format(value: string | undefined) {
    this.query[PlaceTokens.PRM_OUTPUT_FORMAT] = value;
  }

  override getTitleForWindow(): string {
    return  Translator.translateId('launchReport');
  }
}
